import {setScrollTrigger} from './parts/settings/gsap/scrolltrigger';
import {params} from './parts/vars/params';
import {elms} from './parts/vars/elms';
import {resize} from './parts/utils/resize';
import {ham} from './parts/components/common/ham';
import {marquee} from './parts/components/common/marquee';
import {para} from './parts/components/common/para';
import {scrollIn} from './parts/components/common/scrollIn';
import {tabs} from './parts/components/common/tabs';
import {accordion} from './parts/components/common/accordion';
import {copyright} from './parts/components/common/copyright';
import {scrollTo} from './parts/components/common/scrollTo';
import {slider} from './parts/components/common/slider';
import {initializeModal} from './parts/components/common/modal';
// import {twoDigits, addComma, inArray} from './lib/utils';
// {twoDigits, addComma, inArray}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
const bodyClass = isMobile ? 'mobile' : 'pc';
document.body.classList.add(bodyClass);

let initialized: boolean = false;

setTimeout(() => {
  if (!initialized) {
    init();
    initialized = true;
  }
}, 3000);

window.addEventListener('load', () => {
  if (!initialized) {
    init();
    initialized = true;
  }
  params.loadingComplete = true;
});

const init = (): void => {
  document.body.classList.add('loaded');
  if (elms.ham) ham();
  scrollTo();
  marquee();
  para();
  scrollIn();
  tabs();
  accordion();
  copyright();
  slider();
  setScrollTrigger();
  resize();
  initializeModal();
};
